
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./indexResponsive.css";
import Navigations from "./routers/Navigations";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import persistStore from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import "@fontsource/inter"; 
import "@fontsource/inter/400.css"; 




ReactDOM.render(
  <React.StrictMode>
      <Provider store={persistStore().store}>
        <PersistGate loading={null} persistor={persistStore().persistor}>
         
          <Navigations /> 
        </PersistGate>
      </Provider>
    
  </React.StrictMode>,
  document.getElementById("root")
);